import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { DictionaryListComponent } from '@adm-web-app/modules/dictionaries/list/dictionary-list.component';
import { DictionaryEditComponent } from '@adm-web-app/modules/dictionaries/edit/dictionary-edit.component';
import { DictionaryModel, HxDictionaryService } from 'hx-services';
import { DictionaryEntryListComponent } from '@adm-web-app/modules/dictionaries/entry-list/entry-list.component';

const dictionaryResolveFn: ResolveFn<DictionaryModel> = route => inject(HxDictionaryService).getDictionaryById(Number(route.paramMap.get('id')));

export const dictionariesRoutes: Routes = [
  {
    path: '',
    component: DictionaryListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'new',
    component: DictionaryEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':id/edit',
    component: DictionaryEditComponent,
    resolve: {
      dictionary: dictionaryResolveFn,
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
  {
    path: ':id/entries',
    component: DictionaryEntryListComponent,
    resolve: {
      dictionary: dictionaryResolveFn,
    },
    data: {
      breadcrumb: 'Entries'
    }
  },
];
